var _path, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect3, _rect4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastBackgroundGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 85,
    viewBox: "0 0 22 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2122 0H3.68908C1.65165 0 -7.62939e-06 1.65166 -7.62939e-06 3.68909V21.2123H21.2122V0Z",
    fill: "#D1FFD6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.42767,
    height: 9.42767,
    rx: 0.471384,
    transform: "matrix(-1 0 0 1 15.32 5.89258)",
    fill: "#80D47F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2123,
    height: 21.2123,
    transform: "translate(0 21.2627)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89229,
    cy: 26.4487,
    r: 1.82661,
    fill: "#80D47F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6651,
    cy: 26.4484,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3789,
    cy: 26.4484,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89229,
    cy: 31.8693,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6061,
    cy: 31.8693,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.32,
    cy: 31.8693,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89229,
    cy: 37.2901,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6061,
    cy: 37.2901,
    r: 1.76769,
    fill: "#80D47F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.32,
    cy: 37.2901,
    r: 1.76769,
    fill: "#80D47F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2123,
    height: 21.2123,
    transform: "matrix(-1 0 0 1 21.2122 42.5254)",
    fill: "#80D47F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.42767,
    height: 9.42767,
    rx: 0.471384,
    transform: "matrix(-1 0 0 1 15.32 48.418)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1462_9938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2122 63.7881H-7.62939e-06V81.3113C-7.62939e-06 83.3487 1.65165 85.0003 3.68908 85.0003H21.2122V63.7881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1386 66.8958C22.2806 71.0378 22.2806 77.7532 18.1386 81.8952C13.9967 86.0371 7.28126 86.0371 3.13931 81.8952C-1.00264 77.7532 -1.00264 71.0378 3.13931 66.8958C7.28126 62.7539 13.9967 62.7539 18.1386 66.8958ZM6.7964 78.2381C8.9186 80.3603 12.3594 80.3603 14.4816 78.2381C16.6038 76.1159 16.6038 72.6751 14.4816 70.5529C12.3594 68.4307 8.9186 68.4307 6.7964 70.5529C4.67421 72.6751 4.67421 76.1159 6.7964 78.2381Z",
    fill: "#D1FFD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1462_9938"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2122 63.7881H-7.62939e-06V81.3113C-7.62939e-06 83.3487 1.65165 85.0003 3.68908 85.0003H21.2122V63.7881Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastBackgroundGreen);
export default __webpack_public_path__ + "static/media/toast-background-green.295c35268a1813de08d24dcee1a645a7.svg";
export { ForwardRef as ReactComponent };